import { render, staticRenderFns } from "./MenuClientVend.vue?vue&type=template&id=5615ead4&scoped=true&"
import script from "./MenuClientVend.vue?vue&type=script&lang=js&"
export * from "./MenuClientVend.vue?vue&type=script&lang=js&"
import style0 from "./MenuClientVend.vue?vue&type=style&index=0&id=5615ead4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5615ead4",
  null
  
)

export default component.exports